<template>
  <div class="classstudent">
    <div class="head">
      <div class="classinfo">
        <div class="gradename">{{ grade.grade_name }}({{ grade.lesson }})</div>
        <div>
          教师: {{ grade.teacher }}(主教)
          {{ grade.teacher_one ? grade.teacher_one + "(助教)" : "" }}
        </div>
        <div>时间: {{ grade.start_time }}-{{ grade.stop_time }}</div>
      </div>
      <div class="arrived">
        <div>
          <div>{{ grade.count }}</div>
          <div>应到</div>
        </div>
        <div>
          <div>{{ grade.arrived }}</div>
          <div>已到</div>
        </div>
        <div>
          <div>{{ grade.count - grade.arrived }}</div>
          <div>未到</div>
        </div>
      </div>
      <div class="teachersgin">
        <button><div @click="teachersginV(0)">主教签到</div></button>
        <button><div @click="teachersginV(1)">助教签到</div></button>
      </div>
    </div>
    <div class="sginstatus">
      <div
        class="sgins"
        @click="
          sginstatus = 2;
          tabstatus = 3;
        "
        v-show="sginstatus == 1"
      >
        批量签到
      </div>
      <div v-show="sginstatus == 2" class="sginsList">
        <div @click="sginstatus = 1">返回</div>
        <p>|</p>
        <div @click="allSelect">全部已到</div>
        <p>|</p>
        <div @click="clearSelect">清空选择</div>
        <button><div @click="classTimeSubs">提交</div></button>
      </div>
    </div>
    <div class="tab">
      <div :class="tabstatus == 1 ? onLine : ''" @click="tabstatus = 1">
        全部
      </div>
      <div :class="tabstatus == 2 ? onLine : ''" @click="tabstatus = 2">
        已到
      </div>
      <div :class="tabstatus == 3 ? onLine : ''" @click="tabstatus = 3">
        未到
      </div>
    </div>

    <div class="studentCard" v-for="(item, index) in student" :key="item.id">
      <template v-if="tabstatus == 1">
        <div class="top">
          <div class="avatar"><img :src="item.avatar" alt="" /></div>
          <div class="right">
            <div class="name">
              <div>{{ item.name }}</div>
              <div
                v-show="!item.status"
                style="margin-right: 30px; color: red;"
              >
                未签到
              </div>
              <div
                v-show="item.status"
                style="margin-right: 30px; color: green;"
              >
                已签到
              </div>
            </div>
            <div class="classtime">
              <div class="surplus">剩余:{{ item.classtime }}</div>
              <div class="expend">
                已上:{{ item.classtimes - item.classtime }}
              </div>
            </div>
            <div>总课时: {{ item.classtimes }}</div>
            <div>
              本次签到扣除
              <InputNumber
                v-model="deduct"
                controls-outside
                min="1"
                style="width: 100px;"
              ></InputNumber>
              课时
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="one flex" v-if="sginstatus == 1">
            <button>
              <a :href="'tel:' + item.phone">联系电话</a>
            </button>
            <button @click="classTimeSub(item, index)" v-show="!item.status">
              点名签到
            </button>
            <button
              @click="classTimeAdd(item, index)"
              style="color: #c3c0c0"
              v-show="item.status"
            >
              取消签到
            </button>
          </div>
          <div class="batch" v-if="sginstatus == 2">
            <Radio-group
              v-model="studentStatus[index]"
              class="flex"
              size="large"
            >
              <Radio label="1" :disabled="item.status == 1 ? true : false">
                <Icon type="social-apple"></Icon>
                <span>已到</span>
              </Radio>
              <Radio label="2" :disabled="item.status == 1 ? true : false">
                <Icon type="social-apple"></Icon>
                <span>请假</span>
              </Radio>
              <Radio label="3" :disabled="item.status == 1 ? true : false">
                <Icon type="social-apple"></Icon>
                <span>旷课</span>
              </Radio>
            </Radio-group>
          </div>
        </div>
      </template>
      <template v-if="tabstatus == 2 && item.status == 1">
        <div class="top">
          <div class="avatar"><img :src="item.avatar" alt="" /></div>
          <div class="right">
            <div class="name">
              <div>{{ item.name }}</div>
              <div
                v-show="!item.status"
                style="margin-right: 30px; color: red;"
              >
                未签到
              </div>
              <div
                v-show="item.status"
                style="margin-right: 30px; color: green;"
              >
                已签到
              </div>
            </div>
            <div class="classtime">
              <div class="surplus">剩余:{{ item.classtime }}</div>
              <div class="expend">
                已上:{{ item.classtimes - item.classtime }}
              </div>
            </div>
            <div>总课时: {{ item.classtimes }}</div>
            <div>
              本次签到扣除
              <!-- <p style="color: red;display: inline">{{ deduct }}</p> -->
              <InputNumber
                v-model="deduct"
                controls-outside
                min="1"
                style="width: 100px;"
              ></InputNumber>
              课时
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="one flex" v-if="sginstatus == 1">
            <button>
              <a :href="'tel:' + item.phone">联系电话</a>
            </button>
            <button @click="classTimeSub(item, index)" v-show="!item.status">
              点名签到
            </button>
            <button
              @click="classTimeAdd(item, index)"
              style="color: #c3c0c0"
              v-show="item.status"
            >
              取消签到
            </button>
          </div>
          <div class="batch" v-if="sginstatus == 2">
            <Radio-group
              v-model="studentStatus[index]"
              class="flex"
              size="large"
            >
              <Radio label="1" disabled>
                <Icon type="social-apple"></Icon>
                <span>已到</span>
              </Radio>
              <Radio label="2" disabled>
                <Icon type="social-apple"></Icon>
                <span>请假</span>
              </Radio>
              <Radio label="3" disabled>
                <Icon type="social-apple"></Icon>
                <span>旷课</span>
              </Radio>
            </Radio-group>
          </div>
        </div>
      </template>
      <template v-if="tabstatus == 3 && item.status == 0">
        <div class="top">
          <div class="avatar"><img :src="item.avatar" alt="" /></div>
          <div class="right">
            <div class="name">
              <div>{{ item.name }}</div>
              <div
                v-show="!item.status"
                style="margin-right: 30px; color: red;"
              >
                未签到
              </div>
              <div
                v-show="item.status"
                style="margin-right: 30px; color: green;"
              >
                已签到
              </div>
            </div>
            <div class="classtime">
              <div class="surplus">剩余:{{ item.classtime }}</div>
              <div class="expend">
                已上:{{ item.classtimes - item.classtime }}
              </div>
            </div>
            <div>总课时: {{ item.classtimes }}</div>
            <div>
              本次签到扣除
              <!-- <p style="color: red;display: inline">{{ deduct }}</p> -->
              <InputNumber
                v-model="deduct"
                controls-outside
                min="1"
                style="width: 100px;"
              ></InputNumber>
              课时
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="one flex" v-if="sginstatus == 1">
            <button>
              <a :href="'tel:' + item.phone">联系电话</a>
            </button>
            <button @click="classTimeSub(item, index)" v-show="!item.status">
              点名签到
            </button>
            <button
              @click="classTimeAdd(item, index)"
              style="color: #c3c0c0"
              v-show="item.status"
            >
              取消签到
            </button>
          </div>
          <div class="batch" v-if="sginstatus == 2">
            <Radio-group
              v-model="studentStatus[index]"
              class="flex"
              size="large"
            >
              <Radio label="1">
                <Icon type="social-apple"></Icon>
                <span>已到</span>
              </Radio>
              <Radio label="2">
                <Icon type="social-apple"></Icon>
                <span>请假</span>
              </Radio>
              <Radio label="3">
                <Icon type="social-apple"></Icon>
                <span>旷课</span>
              </Radio>
            </Radio-group>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.head {
  background-color: #2980f6;
  color: #fff;
  border-top: 1px solid #2980f7;
  border-radius: 10px;
  /* height: 150px; */
}
.teachersgin,
.arrived {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
}
.gradename {
  font-size: 18px;
  font-weight: 700;
}
.classinfo div {
  margin: 10px 0 0 10px;
}
.teachersgin {
  border-top: 1px solid #fff;
}
.teachersgin button {
  border: 1px solid #fff;
  color: #fff;
  border-radius: 5px;
  margin: 8px 0;
}
.teachersgin button:nth-child(1) {
  margin-right: 40px;
}
.teachersgin button div {
  margin: 5px 15px;
}
.sginstatus {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  background: #fff;
  padding: 10px 0px;
}
.sgins {
  margin: 10px 0 10px 6px;
  font-weight: 700;
  border: 1px solid #2980f7;
  display: inline;
  color: #2980f7;
  padding: 5px 15px;
  border-radius: 5px;
}
.sginsList {
  display: flex;
  margin: 5px 0 5px 6px;
}
.sginsList p {
  margin: 0 5px;
}
.sginsList button {
  background: #2980f7;
  color: #fff;
  margin-left: 130px;
  border-radius: 3px;
}
.sginsList button div {
  margin: 2px 10px;
}
.tab {
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #eee;
  font-weight: 700;
  background: #fff;
}
.tab div {
  padding: 10px 0;
}
.onLine {
  border-bottom: 1px solid #2980f7;
}
.studentCard {
  background: #fff;
  margin-top: 5px;
}
.studentCard .top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar img {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-left: 10px;
}
.avatar {
  flex: 2;
}
.right {
  flex: 8;
}
.right div {
  margin-top: 5px;
}
.right .name {
  display: flex;
  justify-content: space-between;
  font-weight: 700;
}
.classtime {
  display: flex;
}
.classtime .expend {
  margin-left: 40px;
}
.bottom {
  margin: 10px 0;
  border-top: 1px dashed #eee;
  padding: 10px 0;
}
.bottom .flex {
  display: flex;
  justify-content: space-around;
}
.bottom button {
  border: 1px solid #2980f7;
  color: #2980f7;
  padding: 5px 15px;
  border-radius: 5px;
  font-weight: 700;
}
.bottom button a {
  color: #2980f7;
}
</style>

<script>
import {
  gradeLessonStudent,
  getUser,
  teachersgin,
  subclasstime,
  addclasstime
} from "@api/user";

export default {
  name: "ClassStudent",
  data: function() {
    return {
      userInfo: {},
      id: 0,
      grade: {},
      sginstatus: 1,
      onLine: "onLine",
      tabstatus: 1,
      student: [],
      deduct: 1,
      uid: 0,
      studentStatus: []
    };
  },
  methods: {
    gradeLessonStudent() {
      var id = this.id;
      gradeLessonStudent(id).then(res => {
        var grade = res.data.grade;
        grade.count = res.data.student.length;
        grade.arrived = 0;
        res.data.student.forEach(item => {
          if (item.stutas == 1) {
            grade.arrived++;
          }
          var user = res.data.user;
          if (!Array.isArray(user)) user = Object.values(user);
          user.forEach(student => {
            if (item.student_id == student.id) {
              student.status = item.status;
              student.studentId = item.id;
            }
          });
        });
        this.grade = grade;
        this.student = res.data.user;
      });
    },
    //老师签到
    teachersginV(e) {
      var data = {
        uid: this.uid,
        grade: this.grade.grade_name,
        lesson: this.grade.lesson,
        lesson_time: this.grade.start_time,
        status: e,
        lesson_id: this.grade.id
      };
      var _this = this;
      if (this.grade.host_status != 0 && data.status == 0) {
        return this.$Message.error("主教已经签到过了");
      }
      if (this.grade.aid_status != 0 && data.status == 1) {
        return this.$Message.error("助教已经签到过了");
      }
      teachersgin(data)
        .then(res => {
          if (res.status == 200) return _this.$Message.success(res.msg);
          _this.gradeLessonStudent();
        })
        .catch(res => {
          if (res.data.status == 400) return _this.$Message.error(res.msg);
        });
    },
    getUserInfo() {
      getUser().then(res => {
        this.uid = res.data.uid;
      });
    },
    //学员签到
    classTimeSub(item, index) {
      if (Object.keys(this.grade).length) {
        this.student[index].status = 1;
        var _this = this;
        var data = {
          product_id: this.grade.product_id,
          grade_id: this.grade.grade_id,
          uid: [{ status: 1, uid: item.id }],
          times: this.deduct,
          studentid: item.studentId,
          teacher_id: this.grade.teacher_id,
          lesson_id: this.grade.id,
          student_id: item.id,
        };        
      }

      subclasstime(data)
        .then(res => {
          if (res.status == 200) {
            _this.$Message.success("签到成功");
            _this.gradeLessonStudent();
          }
        })
    },
    //学员签到(批量)
    classTimeSubs(item, index) {
      var uids = [],
        student_id = [],
        student = this.student,
        _this = this;

      this.studentStatus.forEach((item, index) => {
        if (item) {
          uids.push({ uid: student[index].id, status: item });
          student_id.push(student[index].studentId);
        }
      });
      var data = {
        product_id: this.grade.product_id,
        grade_id: this.grade.grade_id,
        uid: uids,
        times: this.deduct,
        studentid: student_id
      };
      if (uids.length == 0) return this.$Message.info("请先勾选学员");
      subclasstime(data)
        .then(res => {
          if (res.status == 200) {
            _this.$Message.success("签到成功");
          }
          _this.gradeLessonStudent();
        })
    },
    //学员取消签到
    classTimeAdd(item, index) {
      this.student[index].status = 0;
      var data = {
        product_id: this.grade.product_id,
        grade_id: this.grade.grade_id,
        uid: [{ status: 1, uid: item.id }],
        times: this.deduct,
        studentid: item.studentId,
        teacher_id: this.grade.teacher_id,
        lesson_id: this.grade.id,
        student_id: item.id,
      };
      var _this = this;
      addclasstime(data)
        .then(res => {
          if (res.status == 200) {
            _this.$Message.success("取消签到成功");
          }
          _this.gradeLessonStudent();
        })
    },
    clearSelect() {
      this.studentStatus = [];
    },
    allSelect() {
      var array = [];
      this.student.forEach((item, index) => {
        if (item.status == 0) {
          array[index] = "1";
        }
      });
      this.studentStatus = array;
    }
  },
  watch: {
    $route(to) {
      if (to.name === "ClassStudent") this.id = this.$route.params.id;
      this.gradeLessonStudent();
    }
  },
  mounted: function() {
    this.id = this.$route.params.id;
    this.gradeLessonStudent();
    this.getUserInfo();
  }
};
</script>
